import { isAxiosError } from "axios";
import { useApplyRefcodeStore } from "../../store/applyRefcode";
import { apiWithAuth } from "../authApi";
import { Airdrop, WithdrawAirdrop } from "@/modules/user/types/wallet";

export const getAirdrop = async (
  network: "TON" | "EVM",
  chainId: number
): Promise<Airdrop | undefined> => {
  try {
    const params = new URLSearchParams();
    if (network !== undefined) params.append("network", network.toString());
    if (chainId !== undefined) params.append("chainId", chainId.toString());

    const response = await apiWithAuth.get(
      `/user/airdrop?${params.toString()}`
    );

    const answer = response.data as Airdrop;

    return answer;
  } catch (error) {
    if (isAxiosError(error)) {
      const { setIsReferralError } = useApplyRefcodeStore.getState();
      type ErrorResponse = { message?: string; error?: string };
      const message =
        (error.response?.data as ErrorResponse)?.error || error.message || "";

      if (message.includes("Referral not found")) {
        setIsReferralError(true);
      }
    }
    return undefined;
  }
};

export const postWithdrawAirdrops = async (
  withdrawalType: "ton" | "token",
  network?: "EVM" | "TON" | undefined,
  chainId?: number | undefined
): Promise<WithdrawAirdrop | undefined> => {
  try {
    const response = await apiWithAuth.post("/user/withdraw/airdrops", {
      withdrawalType,
      network,
      chainId: chainId?.toString(),
    });

    const answer = response.data as WithdrawAirdrop;

    return answer;
  } catch (error) {
    return undefined;
  }
};
